(function ($) {
    $.widget('femcare.heroSlide', {
        options: {
            youtubeVideoSelector: null,
            mediabankVideoSelector: null,
            movablePanelSelector: null,
            panelActiveClass: null
        },

        _create: function () {
            var hasVideos = this.element.find(this.options.youtubeVideoSelector).length ||
                this.element.find(this.options.mediabankVideoSelector).length;

            if (!hasVideos) {
                return;
            }

            this.$panel = this.element.find(this.options.movablePanelSelector);

            femcare.shared.pubsub.subscribe('VIDEO_PLAY', this._onVideoPlay.bind(this));
            femcare.shared.pubsub.subscribe('YOUTUBE_VIDEO_PLAYS', this._onVideoPlay.bind(this));

            femcare.shared.pubsub.subscribe('VIDEO_STOP', this._onVideoFinish.bind(this));
            femcare.shared.pubsub.subscribe('YOUTUBE_VIDEO_STOP', this._onVideoFinish.bind(this));

            femcare.shared.pubsub.subscribe('VIDEO_FINISH', this._onVideoFinish.bind(this));
            femcare.shared.pubsub.subscribe('YOUTUBE_VIDEO_FINISH', this._onVideoFinish.bind(this));

            femcare.shared.pubsub.subscribe('YOUTUBE_IFRAME_LOADED', this._animatePanel.bind(this, false));
        },

        _onVideoPlay: function (data) {
            if (this._isVideoWithinGallery(data.$trigger)) {
                this._animatePanel(true);
            } else {
                this._animatePanel(false);
            }
        },

        _onVideoFinish: function (data) {
            if (this._isVideoWithinGallery(data.$trigger)) {
                this._animatePanel(false);
            }
        },

        _animatePanel: function (applyMove) {
            this.$panel.toggleClass(this.options.panelActiveClass, applyMove);
        },

        _isVideoWithinGallery: function ($videoTrigger) {
            return this.element.find($videoTrigger).length;
        }
    });
})(jQuery);

